const options = {
  normal: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  short: {
    month: "short",
    day: "numeric"
  }
};
export function datetime(value, compact = 'normal') {
  const v = isNaN(value) ? value : Number(value);
  const dateValue = new Date(v);
  return dateValue.getTime() ? dateValue.toLocaleDateString("en-GB", options[compact]) : null;
}